import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import RaisedButton from 'material-ui/RaisedButton';

import CreateNewRegion from '../CreateNewRegion';
import OpenPositionAutoComplete from './AutoComplete';
import DateRangeSelector from 'components/Base/DateRangeSelector';

import { updateVesselOrder } from 'actions/vessels/orders';
import Exdd from './Exdd';

class OpenPosition extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            listPorts: [],
            openDialog: false,
            canRequestNewRegion: true,
        };

        this.addOpenPosition = this.addOpenPosition.bind(this);
        this.removeOpenPosition = this.removeOpenPosition.bind(this);

        this.changeOpenPosition = this.changeOpenPosition.bind(this);
    }

    removeOpenPosition(key) {
        const newVesselOrder = _.cloneDeep(this.props.vesselOrder);
        newVesselOrder.open.splice(key, 1);
        this.props.updateVesselOrder(this.props.numberOrderTable, newVesselOrder);
    }

    addOpenPosition() {
        const newVesselOrder = _.cloneDeep(this.props.vesselOrder);
        const firstLPort = this.props.vesselOrder.open[this.props.vesselOrder.open.length - 1];

        newVesselOrder.open.push({
            where: '',
            namePort: '',
            from: firstLPort.from,
            until: firstLPort.until,
        });

        this.props.updateVesselOrder(this.props.numberOrderTable, newVesselOrder);
    }

    changeOpenPosition(key, position) {
        const newVesselOrder = _.cloneDeep(this.props.vesselOrder);
        newVesselOrder.open[key] = {
            ...newVesselOrder.open[key],
            ...position,
        };
        this.props.updateVesselOrder(this.props.numberOrderTable, newVesselOrder);
    }

    changeExdd = (_a, __a, value) => {
        const _order = _.cloneDeep(this.props.vesselOrder);
        _order.maintenance = value;
        this.props.updateVesselOrder(this.props.numberOrderTable, _order);
    }

    render() {
        const errorWhere = this.props.errorWhere ? this.props.errorWhere.messages[0] : '';
        const errorFrom = this.props.errorFrom ? this.props.errorFrom.messages[0] : '';
        const errorUntil = this.props.errorUntil ? this.props.errorUntil.messages[0] : '';

        return (
            <div>
                <div className='row'>
                    <div className='column-left'>
                       Open positions:
                    </div>
                    <div className='column-right'>
                        <RaisedButton
                            labelStyle={{ fontSize: '10px' }}
                            style={{ height: '25px' }}
                            buttonStyle={{ height: '25px', lineHeight: '25px' }}
                            label='Add new position'
                            onClick={this.addOpenPosition}
                            primary
                        />
                    </div>
                </div>
                {
                    this.props.vesselOrder.open.map((openPosition, key) => (
                        <div key={key} >
                            <div className='row'>
                                <div className='column-left'>
                                    {`Open position - ${key + 1}`}
                                </div>
                            </div>

                            <div className='row half'>
                                <OpenPositionAutoComplete
                                    error={errorWhere}
                                    openPosition={openPosition}
                                    portKey={key}
                                    changeOpenPosition={this.changeOpenPosition}
                                />
                                <div className='column-right half'>
                                    <CreateNewRegion
                                        numberOfPort={key}
                                        numberOrderTable={this.props.numberOrderTable}
                                        vesselOrder={this.props.vesselOrder}
                                    />
                                </div>
                            </div>

                            <DateRangeSelector
                                from={openPosition.from}
                                until={openPosition.until}
                                fromHint={openPosition.fromOld}
                                untilHint={openPosition.untilOld}
                                errorFrom={errorFrom}
                                errorUntil={errorUntil}
                                onChange={range => this.changeOpenPosition(key, range)}
                            />

                            <div className='row half'>
                                <div className='column-left'>
                                    { key === 0
                                        ? null
                                        :
                                        <RaisedButton
                                            labelStyle={{ fontSize: '10px' }}
                                            style={{ height: '25px', margin: '8px 0' }}
                                            buttonStyle={{ height: '25px', lineHeight: '25px' }}
                                            label='Remove port'
                                            onClick={() => { this.removeOpenPosition(key); }}
                                            secondary
                                        />
                                    }
                                </div>
                            </div>
                            <div className='row'>
                                <div className='column-left'>
                                        Exddss
                                </div>
                                <div className='column-right'>
                                    <Exdd 
                                        changeExdd={this.changeExdd}
                                        exdd={this.props.vesselOrder.maintenance || null}
                                    />
                                </div>
                            </div>
                        </div>))
                }
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {
        const vesselOrder = state.vesselOrders.items[ownProps.numberOrderTable];

        const errorWhere = vesselOrder.validateErrors.find(validateError => validateError.field === 'open.where');

        const errorFrom = vesselOrder.validateErrors.find(validateError => validateError.field === 'open.from');

        const errorUntil = vesselOrder.validateErrors.find(validateError => validateError.field === 'open.until');

        return {
            numberOrderTable: ownProps.numberOrderTable,
            errorWhere,
            errorFrom,
            errorUntil,
            vesselOrder,
        };
    },
    dispatch => bindActionCreators({
        updateVesselOrder,
    }, dispatch),
)(OpenPosition);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Vessel/Sidebar/Order/OpenPosition/Component.jsx